import axios from "axios";
import { getAuthToken, getRefreshToken } from "../utils/lsMethods";

export default class RefreshService {
    static RefreshToken = () => {
        return axios.post(`api/account/refreshToken`, { authToken: getAuthToken(), refreshToken: getRefreshToken() });
    }
}